import { EVENTS } from '../../bus/events.const';
import { WIRES } from '../wires';
import { Wiring } from '../wiring.interfaces';

export const NO_RESULTS_WIRING: Wiring = {
  [EVENTS.GetFallbackFilterResults]: [
    WIRES.getFallbackFiltersResults
  ]
};
